export const AUTH_MODE_KEY = "auth_mode";
export const AUTH_MODE_INSTANT = "instant";
export const AUTH_MODE_WIDGET = "widget";
export const INSTANT_ACCESS_SID_KEY = "instant_access_sid";
export const INSTANT_ACCESS_SID_PATTERN = /^[A-Za-z0-9]{7}$/;
export const REAUTH_HINT_METHOD_KEY = "reauth_hint_method";
export const REAUTH_HINT_INSTANT_ACCESS_SID_KEY = "reauth_hint_instant_access_sid";

function isValidAuthMode(value) {
  return value === AUTH_MODE_INSTANT || value === AUTH_MODE_WIDGET;
}

function getStorageValue(storage, key) {
  try {
    return storage.getItem(key);
  } catch (_) {
    return null;
  }
}

function setStorageValue(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch (_) {
    // Ignore storage access errors.
  }
}

function removeStorageValue(storage, key) {
  try {
    storage.removeItem(key);
  } catch (_) {
    // Ignore storage access errors.
  }
}

function normalizeInstantAccessSid(value) {
  return typeof value === "string" && INSTANT_ACCESS_SID_PATTERN.test(value) ? value : null;
}

export function getSessionAuthMode(storage = localStorage) {
  const mode = getStorageValue(storage, AUTH_MODE_KEY);
  return isValidAuthMode(mode) ? mode : null;
}

export function getSessionInstantAccessSid(storage = localStorage) {
  return normalizeInstantAccessSid(getStorageValue(storage, INSTANT_ACCESS_SID_KEY));
}

export function getReauthHintAuthMode(storage = localStorage) {
  const mode = getStorageValue(storage, REAUTH_HINT_METHOD_KEY);
  return isValidAuthMode(mode) ? mode : null;
}

export function getReauthHintInstantAccessSid(storage = localStorage) {
  return normalizeInstantAccessSid(getStorageValue(storage, REAUTH_HINT_INSTANT_ACCESS_SID_KEY));
}

export function resolveAuthMode(storage = localStorage) {
  return getSessionAuthMode(storage) || getReauthHintAuthMode(storage);
}

export function resolveInstantAccessSid(storage = localStorage) {
  return getSessionInstantAccessSid(storage) || getReauthHintInstantAccessSid(storage);
}

export function setInstantAccessReauthHint(storage = localStorage, instantAccessSid = null) {
  setStorageValue(storage, REAUTH_HINT_METHOD_KEY, AUTH_MODE_INSTANT);

  const sidToPersist =
    normalizeInstantAccessSid(instantAccessSid) ||
    getSessionInstantAccessSid(storage) ||
    getReauthHintInstantAccessSid(storage);

  if (sidToPersist) {
    setStorageValue(storage, REAUTH_HINT_INSTANT_ACCESS_SID_KEY, sidToPersist);
  } else {
    removeStorageValue(storage, REAUTH_HINT_INSTANT_ACCESS_SID_KEY);
  }
}

export function setWidgetReauthHint(storage = localStorage) {
  setStorageValue(storage, REAUTH_HINT_METHOD_KEY, AUTH_MODE_WIDGET);
  removeStorageValue(storage, REAUTH_HINT_INSTANT_ACCESS_SID_KEY);
}

export function captureReauthHintFromSession(storage = localStorage) {
  const mode = getSessionAuthMode(storage);

  if (mode === AUTH_MODE_INSTANT) {
    setInstantAccessReauthHint(storage, getSessionInstantAccessSid(storage));
    return;
  }

  if (mode === AUTH_MODE_WIDGET) {
    setWidgetReauthHint(storage);
  }
}
